import { getTransactionURL } from 'src/constants/BlockchainConstants'
import { useAppSelector } from 'src/store/store'
import { maskHash } from 'src/constants/ConversionUtils'
import 'src/components/shared/ExplorerTxHashLink.css'
import { CopyLink } from 'src/components/shared/CopyLink'

type Props = {
  blockchain: string
  hash: string
  shouldTruncate?: boolean
}

export const ExplorerTxHashLink: React.FC<Props> = ({
                                                      blockchain,
                                                      hash,
                                                      shouldTruncate = false,
                                                    }) => {
  const selector = useAppSelector
  const network = selector((state) => state.NetworkReducer.network)
  if (!hash || !blockchain) {
    return <div>{'-'}</div>
  }

  // link to transactions page in respective explorers
  const explorerUrl = getTransactionURL(blockchain, hash, network)
  if (!explorerUrl) {
    return <div>{hash} (Link not found)</div>
  }

  const formattedHash = shouldTruncate ? maskHash(hash, 6) : hash
  return <CopyLink copyText={hash} text={formattedHash} url={explorerUrl} />
}
